// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"5f30ed2a","328":"5f30ed2a","331":"5f30ed2a","855":"5f30ed2a"}[chunkId] + ".chunk.css";
};